// extracted by mini-css-extract-plugin
export default {"root":"DFPBanner-module-root","body":"DFPBanner-module-body","link":"DFPBanner-module-link","image":"DFPBanner-module-image"};